import { useState } from 'react';
import { FACILITY_ROLES } from '../../utils/facilityRoles';

export default function InviteComposer({ onSubmit, onCancel }) {
    const [email, setEmail] = useState('');
    const [role, setRole] = useState('case_manager');

    const handleSubmit = (e) => {
        e.preventDefault();
        onSubmit({ role, email: email.trim() || undefined });
    };

    return (
        <form className="invite-composer" onSubmit={handleSubmit}>
            <div className="field">
                <label className="field-label" htmlFor="invite-email">
                    Email <span className="field-label-soft">(optional)</span>
                </label>
                <input
                    id="invite-email"
                    type="email"
                    className="input"
                    placeholder="colleague@example.com"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                />
                <div className="field-hint">Leave blank to generate a shareable invite code.</div>
            </div>
            <div className="field">
                <label className="field-label" htmlFor="invite-role">Role</label>
                <select
                    id="invite-role"
                    className="select"
                    value={role}
                    onChange={(e) => setRole(e.target.value)}
                >
                    {FACILITY_ROLES.map((r) => (
                        <option key={r.id} value={r.id}>{r.label}</option>
                    ))}
                </select>
            </div>
            <div className="invite-composer-actions">
                <button type="button" className="btn btn-ghost" onClick={onCancel}>Cancel</button>
                <button type="submit" className="btn btn-primary">Send invite</button>
            </div>
        </form>
    );
}
